import { render, staticRenderFns } from "./DeanStatSuccessRate.vue?vue&type=template&id=1f607a04"
import script from "./DeanStatSuccessRate.vue?vue&type=script&lang=js"
export * from "./DeanStatSuccessRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports